import React from "react";
import "./custom-fonts.css";
import "./App.css";
import Header from "./Components/Header";
import MainCanvas from "./Components/MainCanvas";
import MainSidebar from "./Components/MainSidebar";
import TopMessage from "./Components/Message";
import OrientationGuard from "./Components/OrientationGuard";

function App() {
    const searchParams = new URLSearchParams(window.location.search);
    const onlyOne = searchParams.get("onlyOne");

    return (
        <div className="haref-app">
            <OrientationGuard>
                <Header />
                <div
                    className="main"
                    style={onlyOne === "true" ? { height: "100vh" } : {}}
                >
                    <TopMessage />
                    <MainCanvas />
                    <MainSidebar />
                </div>
            </OrientationGuard>
        </div>
    );
}

export default App;
